<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ resource.name }}</h3>
      <nav-secondary-vehicle :vehicle="vehicle" />
    </route-header>
    <vehicle-dash />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Vehicle',
  props: ['vehicle'],
  computed: {
    ...mapState({
      auth: state => state.auth,
      resource: state => state.vehicle.data
    })
  },
  mounted () {
    this.show()
  },
  methods: {
    show () {
      this.loading = true
      this.$store.dispatch('show', { object: this.$options.name, id: this.vehicle }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
